import moment from 'moment-timezone';
import validateTime from 'utils/dateAndTimes/validators/validateTime';
import getRulesWithRestrictions from 'utils/dateAndTimes/validators/getRulesWithRestrictions';
import dateAndTimeConstants from 'utils/dateAndTimes/constants';
import dateAndTimeMethods from 'utils/dateAndTimes/methods';
import { methods as addressesMethods } from 'utils/addresses';

function validateTimes(times, loadsInForm, orderType, validations, timeWindow) {
  const timeParams = dateAndTimeConstants.DATE_AND_TIME_KEYS;
  const timesCleaned = timeParams.reduce(
    (acc, timekey) => ({
      ...acc,
      [timekey]: validateTime(times[timekey]).isValid ? times[timekey] : '',
    }),
    {}
  );

  const rules = getRulesWithRestrictions({
    times: { ...times, ...timesCleaned },
    restrictions: {
      maxNumberOfItemsInLoadsBetweenShipments: loadsInForm,
    },
    validations,
    timeWindow,
  });

  const timesJoined = dateAndTimeMethods.joinTimesWithDates(times);
  delete timesJoined.isToday;

  const errors = timeParams.reduce((acc, key) => {
    const today = moment().tz(
      timesJoined[addressesMethods.getTimezoneFromAddressFromTimeKey(key)] ||
        moment.tz.guess()
    );
    const todayCleaned = today.clone().set('second', 0).set('millisecond', 0);

    const timeCleaned = timesJoined[key]
      .clone()
      .set('second', 0)
      .set('millisecond', 0);

    const minCleaned = rules[key].min.value
      .clone()
      .set('second', 0)
      .set('millisecond', 0);
    const maxCleaned = rules[key].max.value
      .clone()
      .set('second', 0)
      .set('millisecond', 0);
    // no past
    let newAcc = { ...(acc || {}) };

    if (timeCleaned.isBefore(todayCleaned, 'minute')) {
      newAcc = { ...newAcc, [key]: [...(newAcc[key] || []), 'past'] };
    }
    // min
    if (timeCleaned.isBefore(minCleaned, 'minute')) {
      newAcc = {
        ...newAcc,
        [key]: [...(newAcc[key] || []), rules[key].min.error],
      };
    }
    // max
    if (timeCleaned.isAfter(maxCleaned, 'minute')) {
      newAcc = {
        ...newAcc,
        [key]: [...(newAcc[key] || []), rules[key].max.error],
      };
    }

    return newAcc;
  }, {});

  return { errors };
}

export default validateTimes;
